import { apiFetch } from '../auth/apiFetch.ts';
import { useQuery } from '@tanstack/react-query';
import type { Robot } from './useRobots.ts';

async function fetchRobot(robotId: string): Promise<Robot> {
  const r = await apiFetch(`/api/robots/${encodeURIComponent(robotId)}`);
  if (!r.ok) throw new Error(`status ${r.status}`);
  return (await r.json()) as Robot;
}

export function useRobot(robotId: string | undefined) {
  return useQuery({
    queryKey: ['robot', robotId] as const,
    queryFn: () => fetchRobot(robotId as string),
    enabled: !!robotId,
    refetchInterval: 5_000,
  });
}
